import React, { useEffect, useRef, useState } from "react";
import ReferenceMaterialUpload from './ReferenceMaterialUpload';
import ReactTooltip from "react-tooltip";
import Constants from "../../Constants";
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { getAxiosResponse } from '../../services/authApiRoutes/APImethods';
import APIUrls from '../../services/APIUrls';
import { transformBlankToNull } from '../../services/Util';
import { useSelector, useDispatch } from 'react-redux'
import $ from "jquery";
import { updateProjectRuleLanguage, addContact, removeContact, addReplaceContact } from "../../redux/reducers/DynamicAssetSlice"
import { updateSourceLanguage } from '../../redux/reducers/CreateProjectSourceLanguageSlice';
import { updateTargetLanguage } from '../../redux/reducers/CreateProjectTargetLanguageSlice';
import { RotatingLines } from "react-loader-spinner";
import { handleError } from "../../services/authApiRoutes/APImethods";
import { ConditionalBlock } from "../../ConditionalBlock";
import SuccessMessage from "../SuccessMessage";
import { updateCanSubmitTranslation } from "../../redux/reducers/AsyncAssetUploadSlice";
import { SuccessTick } from "../../AppIcons";
import TranslationMemorySelection from './TranslationMemorySelection';
import {updateProjectInfo } from '../../redux/reducers/ProjectInfoSlice';
import ProjectRequestIntegration from "../../pages/vendor/ProjectRequestIntegration";

export default function DynamicAssets() {
  const scrollRef = useRef(null);
  const searchContactRef = useRef(null);
  const { t } = useTranslation();
  const translate = t;
  const aaaSelected = useSelector((aaaChecked) => aaaChecked.contrast).value;
  const dispatch = new useDispatch();
  const custBootstrapDataRedux = useSelector(store => store.customer_bootstrap_data).value;
  const projectInfo = useSelector((reduxStore) => reduxStore.project_info).value;
  const projectRules = useSelector(reduxStore => reduxStore.dynamic_asset).projectRules;
  const contacts = useSelector(reduxStore => reduxStore.dynamic_asset).contacts;
  const sourceLang = useSelector(reduxStore => reduxStore.source_language_for_project_creation).value;
  
  const contentTypeRedux = useSelector(reduxStore => reduxStore.content_type_for_project_creation).value;
  const selectedTreeData = useSelector(redux => redux.tree_structure).selectedTreeData;
  const backgroundAssetUploadInfo = useSelector((redux) => redux.asset_upload_background).value;
  const projectRequestIntegrationRedux = useSelector((redux) => redux.project_request_integration).value;
  const [sourceLanguage, setSourceLanguage] = useState([]);
  const [sourceLanguageOptions, setSourceLanguageOptions] = useState([]);
  const [targetLanguage, setTargetLanguage] = useState([]);
  const [targetLanguageOptions, setTargetLanguageOptions] = useState([]);
  const [allTargetLanguageCollection, setAllTargetLanguageCollection] = useState([]);
  const [allSourceLanguageCollection, setAllSourceLanguageCollection] = useState([]);
  const [selectedSourceLanguage, setSelectedSourceLanguage] = useState("");
  const [selectedTargetLanguageList, setSelectedTargetLanguageList] = useState([]);
  const [selectedRuleValueLanguage, setSelectedRuleValueLanguage] = useState([]);
  const [selectedFilteredRuleValueLanguage, setSelectedFilteredRuleValueLanguage] = useState([]);
  const [contact, setContact] = useState();
  const [isContactLoading, setContactLoading] = useState(false);
  const [isSourceLanguageLoading, setSourceLanguageLoading] = useState(true);
  const [isTargetLanguageLoading, setTargetLanguageLoading] = useState(true);
  const [tabOption,setTabOption] = useState("REFERENCE_MATERIAL");
  const [segmentContactInfo, setSegmentContactInfo] = useState({});//keeps the state of the contacts and the selected contact {<componentId>:{contacts:[],selectedContact:{}}

  function expandRightFunction() {
    var element = document.getElementById("container");
    element.classList.toggle("expand-right");
  }

  const iconComponent = () => {
    return (
      <i className="arrow-icon">
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='12'
          height='8'
          viewBox='0 0 12 8'
          fill='none'
        >
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M0.21967 0.815454C0.512563 0.519849 0.987437 0.519849 1.28033 0.815454L6 5.57882L10.7197 0.815454C11.0126 0.519849 11.4874 0.519849 11.7803 0.815454C12.0732 1.11106 12.0732 1.59033 11.7803 1.88593L6.53033 7.18455C6.23744 7.48015 5.76256 7.48015 5.46967 7.18455L0.21967 1.88593C-0.0732233 1.59033 -0.0732233 1.11106 0.21967 0.815454Z'
            fill='#076FA3'
          ></path>
        </svg>
      </i>
    );
  }

  const DepartmentProp = {
    PaperProps: {
      style: {
        fontSize: "85.71429%",
        color: aaaSelected ? "white" : "#1C233C",
        background: aaaSelected ? "black" : "#FFF",
      },
      arialabel: "list",
    },
  };

  const focusfirstElement = (e) => {
    if (e.target.nextSibling === null && e.key === "ArrowDown") {
      $(".MuiList-root").find("li").first().trigger("focus");
    }
    if (e.target.prevSibling === null) {
      $(".MuiList-root").find("li").last().trigger("focus");
    }
  };

  useEffect(() => {
    getAxiosResponse(APIUrls.SOURCE_LANGUAGE)
      .then((res) => {
        setSourceLanguageLoading(false);
        if (res.data.code === 200) {
          const dbSourceLang = transformBlankToNull(res.data.data);
          setSourceLanguage(dbSourceLang);
          setAllSourceLanguageCollection(dbSourceLang);
          if(custBootstrapDataRedux?.roleSet?.customerProjectRequester)
            {
              dispatch(updateProjectInfo({}));
            }

          if(projectInfo.sourceLanguage && !custBootstrapDataRedux?.roleSet?.customerProjectRequester){
            setSelectedSourceLanguage(dbSourceLang.filter(lang=>projectInfo.sourceLanguage === lang.language)[0]);
          }
          
        }
      })
      .catch((err) => {
        handleError(err);
        setSourceLanguageLoading(false);
      });

    getAxiosResponse(APIUrls.TARGET_LANGUAGE)
      .then((res) => {
        setTargetLanguageLoading(false);
        if (res.data.code === 200) {
          const dbTargetLang = transformBlankToNull(res.data.data);
          setTargetLanguage(dbTargetLang);
          setAllTargetLanguageCollection(dbTargetLang);
          const ruleValueLanguages = [];
          projectRules.map(rule => {
            rule.ruleValues.map(ruleValue => {
              if (ruleValue.language !== null) {
                ruleValueLanguages.push({
                  display: ruleValue.langDisplay,
                  language: ruleValue.language,
                  code: ruleValue.langCode
                });
              }
            })
          })
          const uniqueRuleValueLanguages = [...new Map(ruleValueLanguages.map((rvl) => [rvl.code, rvl])).values()];
          setSelectedRuleValueLanguage(uniqueRuleValueLanguages);
          setSelectedTargetLanguageList(ruleValueLanguages)
        }
      })
      .catch((err) => {
        handleError(err);
        setTargetLanguageLoading(false);
      });

  }, []);

  useEffect(() => {
    if (selectedSourceLanguage === "" && !isSourceLanguageLoading) {
      dispatch(updateSourceLanguage({}));
    } else {
      dispatch(updateSourceLanguage(selectedSourceLanguage));
    }
  }, [selectedSourceLanguage]);

  useEffect(() => {
    if (!isTargetLanguageLoading) {
      dispatch(updateTargetLanguage(selectedTargetLanguageList));
    }
  }, [selectedTargetLanguageList]);

  useEffect(() => {
    var sourceLangOptions = [];
    sourceLanguage?.map((source) => {
      sourceLangOptions.push({
        label: source.display,
        value: source,
      });
    });
    setSourceLanguageOptions(sourceLangOptions);
  }, [sourceLanguage])

  useEffect(() => {
    var targetLangOptions = [];
    targetLanguage?.map((target) => {
      targetLangOptions.push({
        label: target.display,
        value: target,
      });
    });
    setTargetLanguageOptions(targetLangOptions);
  }, [targetLanguage])

  useEffect(() => {
    const ruleValueLanguages = [];
    projectRules.map(rule => {
      rule.ruleValues.map(ruleValue => {
        if (ruleValue.language !== null) {
          let componentId = ruleValue.componentId;
          ruleValueLanguages.push({
            display: ruleValue.langDisplay,
            language: ruleValue.language,
            code: ruleValue.langCode,
            componentId : componentId
          });
          if(projectInfo?.projectContentType === "MARKETOREST" && componentId !== null ){
            loadSegmentContacts(componentId);
            if(segmentContactInfo[componentId]?.contacts?.length > 0 && !segmentContactInfo[componentId]?.selectedContact){//select first contact as default selected
                selectContact(componentId, segmentContactInfo[componentId]?.contacts[0]);
            }
          }
        }
      })
    })
    const uniqueRuleValueLanguages = [...new Map(ruleValueLanguages.map((rvl) => [rvl.code, rvl])).values()];
    setSelectedRuleValueLanguage(uniqueRuleValueLanguages);
  }, [projectRules])

    const loadSegmentContacts = async (componentId) => {
           if(componentId && ! segmentContactInfo[componentId]?.contacts ){
                    setContactLoading(true);
                    getAxiosResponse(APIUrls.MARKETO_REST_PREVIEW_LEADS(projectInfo?.id, componentId))
                      .then((res) => {
                        setContactLoading(false);
                        if (res.data.code === 200 && res.data.data?.length > 0) {
                            let contacts = res.data.data;
                            contacts.push({value:-1,label:"Other",emailAddress:""});
                            let newSegmentContactInfo = Object.assign({}, segmentContactInfo);
                            newSegmentContactInfo[componentId] = { contacts: contacts , selectedContact : contacts[0]};//select first contact as default selected
                            setSegmentContactInfo(newSegmentContactInfo);
                        }
                      })
                      .catch((err) => {
                        setContactLoading(false);
                        handleError(err);
                      });
            }
    }

    const selectContact = (componentId, contact) => {
        let newSegmentContactInfo = Object.assign({}, segmentContactInfo);
        newSegmentContactInfo[componentId].selectedContact = contact;
        setSegmentContactInfo(newSegmentContactInfo);
    }


  useEffect(() => {
    //update the change in contact selection in redux
    selectedRuleValueLanguage.map(ruleValueLanguage => {
        let contact = segmentContactInfo[ruleValueLanguage.componentId]?.selectedContact;
        if (contact) {
            if(contact?.value === -1){
                let reduxContacts = contacts.filter(contact => {return contact.langCode === ruleValueLanguage.code });
                let reduxContact = reduxContacts?.length > 0 ? reduxContacts[0] : null;//selected contact in redux
                if(reduxContact !== null ){
                    //drop down option for selected redux contact
                    let selectedSegmentContacts = segmentContactInfo[ruleValueLanguage.componentId]?.contacts.filter(contact => {return contact.value === reduxContact.contact.contactId});
                    if(selectedSegmentContacts?.length > 0){//if the last selection was from dropdown then only remove from redux
                        dispatch(removeContact({ langCode: ruleValueLanguage.code }))
                    }
                }
            }else{
                let newContact = {
                    contactId: contact.value,
                    emailAddress: contact.emailAddress,
                    label: contact.label,
                    language: ruleValueLanguage.language
                };
                dispatch(addReplaceContact({ langCode: ruleValueLanguage.code, contact: newContact }));
            }
        }
    })
  },[segmentContactInfo])

  useEffect(() => {
    let languages = [];
    selectedRuleValueLanguage.map(rvl => {
      if (languages.length === 0 || languages.find(l => l.code !== rvl.code)) {
        languages.push(rvl);
      }
    })
    setSelectedFilteredRuleValueLanguage(languages)
  }, [selectedRuleValueLanguage])


  const handleSourceLanguageChange = (event) => {
    setSelectedSourceLanguage(event.value)
    setSourceLanguage(allSourceLanguageCollection.filter(lang => event.label !== lang.display));
  };

  const handleTargetLanguageChange = (event, ruleIndex, ruleValueIndex) => {
    let targetLang = event.value;
    dispatch(updateCanSubmitTranslation(true));
    dispatch(updateProjectRuleLanguage({
      ruleIndex: ruleIndex,
      ruleValueIndex: ruleValueIndex,
      language: targetLang.language,
      langCode: targetLang.code,
      langDisplay: targetLang.display
    }))
  };

  const removeRuleValueLanguage = (componentId, ruleIndex, ruleValueIndex) => {

    //remove the selected contact
    if(projectInfo?.projectContentType === "MARKETOREST" && componentId && segmentContactInfo[componentId ]?.contacts?.length > 0){
        selectContact(componentId, null);
    }

    dispatch(updateProjectRuleLanguage({
      ruleIndex: ruleIndex,
      ruleValueIndex: ruleValueIndex,
      language: null,
      langCode: null,
      langDisplay: null
    }))
  }

  useEffect(() => {
    let targetLangs = [];
    let flatRuleValueLangs = projectRules
      .flatMap(rule => (rule.ruleValues
        .filter(ruleValue => ruleValue.language !== null && ruleValue.language !== selectedSourceLanguage?.language)
        .map(ruleValue => ruleValue.language)));

    flatRuleValueLangs.map(rvLang => {
      let lang = allTargetLanguageCollection.find(lang => lang.language === rvLang);
      if (!targetLangs.includes(lang)) {
        targetLangs.push(lang)
      }
    })
    setSelectedTargetLanguageList(targetLangs);
  }, [projectRules])

  const clearSourceLanguage = (event) => {
    setSelectedSourceLanguage("");
    setSourceLanguage(allSourceLanguageCollection);
    setTargetLanguage(allTargetLanguageCollection);
  }

  const clearSourceLanguageOnKeydown = (event) => {
    if (event.key === Constants.ENTER) {
      clearSourceLanguage();
    }
  }

  const onSearchContactSubmit = (event) => {
    if (event.key === Constants.ENTER) {
      onSearchContactChange(event);
    }
  }

  const getIntegrationName = () => {
    let integrationName;
    if (contentTypeRedux == Constants.MARKETOREST) {
      integrationName = Constants.MARKETO_CONTENT_TYPE_DISPLAY
    } else if (contentTypeRedux == Constants.ELOQUA) {
      integrationName = Constants.ELOQUA_CONTENT_TYPE_DISPLAY
    }
    return integrationName;
  }

  const onSearchContactChange = (event) => {
    if (event.target.value.length >= 3) {
      setContactLoading(true);
      let searchUrl;
      if (contentTypeRedux == Constants.MARKETOREST) {
        searchUrl = APIUrls.MARKETO_REST_PREVIEW_CONTACT(projectInfo?.id) + `?textToSearch=${event.target.value}`
      } else if (contentTypeRedux == Constants.ELOQUA) {
        searchUrl = APIUrls.CUSTOMER_ELOQUA_CONTACT_SEARCH(event.target.value)
      }
      getAxiosResponse(searchUrl
      ).then(res => {
        setContactLoading(false);
        if (res.data.code === 200) {
          const contacts = transformBlankToNull(res.data.data);
          if (contacts.length === 1) {
            let contact = contacts[0];
            setContact(contact);
            let newContact = {
              contactId: contact.value,
              emailAddress: contact.emailAddress,
              label: contact.label,
              language: event.target.getAttribute('lang-name')
            }
            dispatch(addContact({ langCode: event.target.getAttribute('lang-code'), contact: newContact }))
          }
        }
      }).catch(err => {
        handleError(err)
        setContactLoading(false);
      })
    }
  }

  const removeConact = (componentId, event, langCode) => {
    //remove the selected contact
    if(projectInfo?.projectContentType === "MARKETOREST" && componentId && segmentContactInfo[componentId]?.contacts?.length > 0){
        selectContact(componentId, null);
    }
    dispatch(removeContact({ langCode: langCode }))
  }

  const clopseExpandAccordion = (accordion) => {
    if (accordion.hasClass("open")) {
      accordion.removeClass("open")
    } else {
      accordion.addClass("open")
    }
  }

  const addDepartmentSelectAttrb = (e) => {
    setTimeout(() => {
      $(".MuiList-root").find("li").first().css("opacity", 0);
      $(".MuiList-root").find("li").first().css("height", 0);
      $(".MuiList-root").find("li").first().css("padding", 0);
      $(".MuiList-root").attr("aria-label", "Delivery Status list");
    }, 200);
  };

  const stylesMonthSelect = {

  };

  function renderValidationErrors() {
    return (
        backgroundAssetUploadInfo.validationErrors && backgroundAssetUploadInfo.validationErrors.map((validation, index) => (
            <div className="flex" key={index}>
                {index + 1}.&nbsp;<strong>{validation.name}</strong>&nbsp;:&nbsp;
                {validation.error !== "" ? <p className={contentTypeRedux !== Constants.ELOQUA ? "error-alert" : "warning"}>{validation.error}</p> : SuccessTick}
            </div>
        ))
    );
  }

  return (
    <>
      <div className={isContactLoading ? "gb-overlay show" : "gb-overlay hide"}>
        <div className="gb-loader">
          <RotatingLines
            strokeColor="#0096FF"
            strokeWidth="5"
            width="196"
            visible={true}
          />
        </div>
      </div>

      <div>

        <div className="create-project-section">
          <div className="source-and-target-block">
            <h3>Source Materials for {projectRequestIntegrationRedux.contentName || getIntegrationName()}</h3>
            <div className="lang-selection-block">
              <h5 className="heading-width-border">Language Selection</h5>
              <div className="flex mar-bot30">
                <div className="global-dropdown-block flex mb-0">
                  <label>Select source language</label>
                  <div className="global-dropdown-select">
                    <Select
                      menuShouldScrollIntoView={false}
                      closeMenuOnSelect={true}
                      classNamePrefix='cw'
                      IconComponent={iconComponent}
                      autoFocus={true}
                      value={selectedSourceLanguage}
                      onChange={event => handleSourceLanguageChange(event)}
                      onOpen={event => addDepartmentSelectAttrb(event)}
                      renderValue={(selected) => "Select Source Language"}
                      displayEmpty
                      MenuProps={DepartmentProp}
                      style={stylesMonthSelect}
                      className={selectedSourceLanguage === '' ? '' : 'after-selection'}
                      options={sourceLanguageOptions}
                    />

                  </div>
                  <div className="multiselect-output flex btn-gap ml-15">
                    {selectedSourceLanguage && <button className="m-0" onClick={(e) => clearSourceLanguage(e)} onKeyDown={(e) => clearSourceLanguageOnKeydown(e)}>
                      <strong>{selectedSourceLanguage.display}</strong>
                      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none">
                        <path d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067" stroke="#213248" strokeWidth="1.5" stroke-linecap="round" strokeLinejoin="round"></path>
                      </svg>
                    </button>}
                  </div>

                </div>
              </div>
            </div>
            <div className="target-selection-block">
              <h5 className="heading-width-border heading-tooltip flex-center">Select target language
                <div className="gb-tooltip" role="tooltip" aria-label="tooltip content" tabindex="0" aria-expanded="false">
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M8 15C6.14348 15 4.36301 14.2625 3.05025 12.9497C1.7375 11.637 1 9.85652 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8C15 9.85652 14.2625 11.637 12.9497 12.9497C11.637 14.2625 9.85652 15 8 15ZM8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16Z" fill="#64748B"></path>
                      <path d="M8.92995 6.588L6.63995 6.875L6.55795 7.255L7.00795 7.338C7.30195 7.408 7.35995 7.514 7.29595 7.807L6.55795 11.275C6.36395 12.172 6.66295 12.594 7.36595 12.594C7.91095 12.594 8.54395 12.342 8.83095 11.996L8.91895 11.58C8.71895 11.756 8.42695 11.826 8.23295 11.826C7.95795 11.826 7.85795 11.633 7.92895 11.293L8.92995 6.588ZM8.99995 4.5C8.99995 4.76522 8.8946 5.01957 8.70706 5.20711C8.51952 5.39464 8.26517 5.5 7.99995 5.5C7.73474 5.5 7.48038 5.39464 7.29285 5.20711C7.10531 5.01957 6.99995 4.76522 6.99995 4.5C6.99995 4.23478 7.10531 3.98043 7.29285 3.79289C7.48038 3.60536 7.73474 3.5 7.99995 3.5C8.26517 3.5 8.51952 3.60536 8.70706 3.79289C8.8946 3.98043 8.99995 4.23478 8.99995 4.5Z" fill="#64748B"></path>
                    </svg>
                  </span>
                  <div className="wrap-tooltip-content">
                    <div className="gb-tooltip-content">
                      <div className="triangle"></div>
                      <p>
                        Indicates source language segment
                      </p>
                    </div>
                  </div>
                </div>
              </h5>
              <p>For each segmentation rule, you must specify which segment contains the source language. Assign one target language for the segments you want translated.</p>
              {projectRules?.map((rule, ruleIndex) => {
                return (<div className="integration-accordion-list open" id={`rule-${ruleIndex}-accordion`}>
                  <div className="accordion-heading flex">
                    <div className="left"><strong>Segmentation: {rule.name}</strong></div>
                    <div className="right" onClick={() => clopseExpandAccordion($(`#rule-${ruleIndex}-accordion`))}>
                      <svg className="plus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                        <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"></circle>
                        <rect x="12.2773" y="6.5" width="1.44444" height="13" rx="0.722222" fill="#1D4ED8"></rect>
                        <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"></rect>
                      </svg>
                      <svg className="minus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                        <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"></circle>
                        <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"></rect>
                      </svg>
                    </div>
                  </div>
                  <div className="integration-accordion-content">
                    <div className="w-d100 inline-dropdown">
                      {rule.ruleValues.map((ruleValue, ruleValueIndex) => {
                        return (<div className="flex mar-bot30">
                          <div className="global-dropdown-block flex mb-0">
                            <label>{ruleValue.name}</label>
                            <div className="m-w100">
                              <small>Add +</small>
                              {ruleValue.language !== null ?
                                (
                                  <div className="multiselect-output flex">
                                    <button onClick={e => removeRuleValueLanguage(ruleValue?.componentId, ruleIndex, ruleValueIndex)}>
                                      <strong>{ruleValue.langDisplay}</strong>
                                      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none">
                                        <path d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067" stroke="#213248" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                      </svg>
                                    </button>
                                  </div>
                                )
                                :
                                (
                                  <div className="global-dropdown-select">
                                    <Select
                                      menuShouldScrollIntoView={false}
                                      closeMenuOnSelect={true}
                                      classNamePrefix='cw'
                                      IconComponent={iconComponent}
                                      autoFocus={true}
                                      value={selectedSourceLanguage}
                                      onChange={event => handleTargetLanguageChange(event, ruleIndex, ruleValueIndex)}
                                      onOpen={event => addDepartmentSelectAttrb(event)}
                                      renderValue={(selected) => "Select Target Language"}
                                      displayEmpty
                                      MenuProps={DepartmentProp}
                                      style={stylesMonthSelect}
                                      className={selectedSourceLanguage === '' ? '' : 'after-selection'}
                                      options={targetLanguageOptions}
                                    />
                                  </div>
                                )
                              }
                            </div>
                          </div>
                        </div>)
                      })}
                    </div>
                  </div>
                </div>)
              })}
            </div>
            {renderValidationErrors()}

            {selectedRuleValueLanguage?.length > 0 &&
              <div className="target-selection-block select-preview-contact">
                <h5 className="heading-width-border flex-center">Select preview contact (Optional)
                  <div className="tooltip-container">
                    <div className="flex" tabIndex="0"
                      data-padding="10px 10px 10px 10px"
                      data-place="right"
                      data-tip={Constants.SELECT_PREVIEW_CONTACT}
                      data-for="preview-tooltip"
                    >
                      <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M8 0C6.41775 0 4.87104 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346629 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0ZM8 14.6667C6.68146 14.6667 5.39253 14.2757 4.2962 13.5431C3.19987 12.8106 2.34539 11.7694 1.84081 10.5512C1.33622 9.33305 1.2042 7.9926 1.46144 6.6994C1.71867 5.40619 2.35361 4.2183 3.28596 3.28595C4.21831 2.3536 5.4062 1.71867 6.6994 1.46143C7.99261 1.2042 9.33305 1.33622 10.5512 1.8408C11.7694 2.34539 12.8106 3.19987 13.5431 4.2962C14.2757 5.39253 14.6667 6.68146 14.6667 8C14.6667 8.87548 14.4942 9.74238 14.1592 10.5512C13.8242 11.3601 13.3331 12.095 12.714 12.714C12.095 13.3331 11.3601 13.8242 10.5512 14.1592C9.74239 14.4942 8.87548 14.6667 8 14.6667Z" fill="#64748B"></path><path d="M7.99948 12.3798C7.76962 12.3798 7.54918 12.2885 7.38665 12.126C7.22412 11.9634 7.13281 11.743 7.13281 11.5132V7.51315C7.13281 7.2833 7.22412 7.06286 7.38665 6.90033C7.54918 6.73779 7.76962 6.64648 7.99948 6.64648C8.22933 6.64648 8.44977 6.73779 8.6123 6.90033C8.77484 7.06286 8.86614 7.2833 8.86614 7.51315V11.5132C8.86614 11.743 8.77484 11.9634 8.6123 12.126C8.44977 12.2885 8.22933 12.3798 7.99948 12.3798Z" fill="#64748B"></path><path d="M7.9668 5.34766C8.51908 5.34766 8.9668 4.89994 8.9668 4.34766C8.9668 3.79537 8.51908 3.34766 7.9668 3.34766C7.41451 3.34766 6.9668 3.79537 6.9668 4.34766C6.9668 4.89994 7.41451 5.34766 7.9668 5.34766Z" fill="#64748B"></path>
                      </svg>
                    </div>
                    <ReactTooltip
                      className="tooltip"
                      id="preview-tooltip"
                    ></ReactTooltip>
                  </div>
                </h5>
                <p className="flex">For each language, select a {getIntegrationName()} Contact to preview translated {getIntegrationName()} assets in OneReview
                  <div className="tooltip-container">
                    <div tabIndex="0"
                      data-padding="10px 10px 10px 10px"
                      data-place="right"
                      data-tip={Constants.PREVIEW_TRANSLATED}
                      data-for="OneReview-tooltip"
                    >
                      <svg
                        className="svg-tooltip-icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M512 81.408a422.4 422.4 0 1 0 422.4 422.4A422.4 422.4 0 0 0 512 81.408z m26.624 629.76a45.056 45.056 0 0 1-31.232 12.288 42.496 42.496 0 0 1-31.232-12.8 41.984 41.984 0 0 1-12.8-30.72 39.424 39.424 0 0 1 12.8-30.72 42.496 42.496 0 0 1 31.232-12.288 43.008 43.008 0 0 1 31.744 12.288 39.424 39.424 0 0 1 12.8 30.72 43.008 43.008 0 0 1-13.312 31.744z m87.04-235.52a617.472 617.472 0 0 1-51.2 47.104 93.184 93.184 0 0 0-25.088 31.232 80.896 80.896 0 0 0-9.728 39.936v10.24h-64v-10.24a119.808 119.808 0 0 1 12.288-57.344A311.296 311.296 0 0 1 555.52 460.8l10.24-11.264a71.168 71.168 0 0 0 16.896-44.032A69.632 69.632 0 0 0 563.2 358.4a69.632 69.632 0 0 0-51.2-17.92 67.072 67.072 0 0 0-58.88 26.112 102.4 102.4 0 0 0-16.384 61.44h-61.44a140.288 140.288 0 0 1 37.888-102.4 140.8 140.8 0 0 1 104.96-38.4 135.68 135.68 0 0 1 96.256 29.184 108.032 108.032 0 0 1 36.352 86.528 116.736 116.736 0 0 1-25.088 73.216z" />
                      </svg>
                    </div>
                    <ReactTooltip
                      className="tooltip"
                      id="OneReview-tooltip"
                    ></ReactTooltip>
                  </div>
                </p>

                <p className="mar-bot30"><strong>Language List</strong></p>
                {selectedRuleValueLanguage?.map(language => {
                  return (<>
                    <div className="flex mar-bot16">
                      <div className="global-dropdown-block flex mb-0">
                        <label>{language.display}</label>
                        {projectInfo?.projectContentType === "MARKETOREST" && language.componentId !== null
                        && segmentContactInfo[language.componentId]?.contacts?.length > 0
                        && segmentContactInfo[language.componentId]?.selectedContact?.value !== -1 ?
                           <div className="global-dropdown-select">
                                                               <Select
                                                                 menuShouldScrollIntoView={false}
                                                                 closeMenuOnSelect={true}
                                                                 classNamePrefix='cw'
                                                                 IconComponent={iconComponent}
                                                                 autoFocus={true}
                                                                 //defaultValue = {getLanguageSegmentLeads(language)[0]}
                                                                 value={segmentContactInfo[language.componentId]?.selectedContact}
                                                                 onChange={event => selectContact(language.componentId, event)}
                                                                 onOpen={event => addDepartmentSelectAttrb(event)}
                                                                 renderValue={(selected) => "Select Target Language"}
                                                                 displayEmpty
                                                                 MenuProps={DepartmentProp}
                                                                 style={stylesMonthSelect}
                                                                 options={segmentContactInfo[language.componentId]?.contacts}
                                                               />
                                                             </div>

                        :
                        <input type="text" className="form-control-sm" title={language.display} lang-code={language.code} lang-name={language.language}
                          onChange={event => onSearchContactChange(event)} onKeyDown={event => onSearchContactSubmit(event)} />
                         }
                      </div>
                      {contacts.map(contact => {
                        return (<>
                          {contact.langCode === language.code &&
                            <div className="multiselect-output flex">
                              <button lang-code={language.code} onClick={e => removeConact(language.componentId, e, language.code)}>
                                <strong>{contact.contact?.label}</strong>
                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none">
                                  <path d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067" stroke="#213248" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                </svg>
                              </button>
                            </div>
                          }
                        </>)
                      })}
                    </div>

                  </>)
                })}
              </div>
            }

            <div className="materials-tab">
              <h5 className="heading-width-border">Reference Materials</h5>
              <div className="listing-tab-block flex">
                <ul className="listing-tab-link flex" role="tablist">
                    <li role="none">
                  <button className={tabOption === "REFERENCE_MATERIAL" ? "active" : ""} onClick={()=>setTabOption("REFERENCE_MATERIAL")}
                    role="tab"
                  aria-label={translate("project_listing.reference_materials")}
                  aria-selected="true"    
                  >
                  {translate("project_listing.reference_materials")}</button>
                  </li>
                  <li role="none">
                  <button className={tabOption === "TRANSLATION_MATERIAL" ? "active" : ""} onClick={()=>setTabOption("TRANSLATION_MATERIAL")}
                    role="tab"
                  aria-label="Translation Materials"
                  aria-selected="true"    
                  >
                  Translation Materials
                  </button>
                  </li>
                </ul>
              </div>
              <div className={tabOption === "REFERENCE_MATERIAL" ? "materials-tab-content flex" : "materials-tab-content flex hide"}>
                <ReferenceMaterialUpload />
              </div>
              <div className={tabOption === "TRANSLATION_MATERIAL" ? "materials-tab-content flex" : "materials-tab-content flex hide"}>
						    <TranslationMemorySelection projectId={projectInfo.id}/>
					    </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
